module.exports = __webpack_public_path__ + "img/ajax-logo.1f32cda1.png";